const s = {
  name: "Users3",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11,0C8.2,0,6,2.2,6,5c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5C16,2.2,13.8,0,11,0z M8,5c0-1.7,1.3-3,3-3
			c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C9.3,8,8,6.7,8,5z"/>
		<path class="st0" d="M29,0c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5c2.8,0,5-2.2,5-5C34,2.2,31.8,0,29,0z M26,5c0-1.7,1.3-3,3-3
			c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3C27.3,8,26,6.7,26,5z"/>
		<path class="st0" d="M15,17c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5s-2.2,5-5,5C17.2,22,15,19.8,15,17z M20,14c-1.7,0-3,1.3-3,3
			c0,1.7,1.3,3,3,3c1.7,0,3-1.3,3-3C23,15.3,21.7,14,20,14z"/>
		<path class="st0" d="M11,31c0-2.8,2.2-5,5-5h8c2.8,0,5,2.2,5,5v9h2v-9c0-3.9-3.1-7-7-7h-8c-3.9,0-7,3.1-7,7v9h2V31z"/>
		<path class="st0" d="M7,14c-2.8,0-5,2.2-5,5v9H0v-9c0-3.9,3.1-7,7-7h4v2H7z"/>
		<path class="st0" d="M33,12h-4v2h4c2.8,0,5,2.2,5,5v9h2v-9C40,15.1,36.9,12,33,12z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Users3
};
